import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { BookOpen, ClipboardList, GraduationCap, LayoutDashboard, LogOut, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const ITEMS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Lead CRM", icon: Users },
  { to: "/admin/applications", label: "Applications", icon: ClipboardList },
  { to: "/admin/courses", label: "Courses", icon: BookOpen },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-navy-base flex" data-testid="admin-layout">
      <aside className="w-60 shrink-0 bg-navy-deep border-r border-white/10 flex flex-col fixed inset-y-0">
        <div className="flex items-center gap-2.5 px-5 h-16 border-b border-white/10">
          <div className="w-8 h-8 rounded-lg bg-orange-600 flex items-center justify-center">
            <GraduationCap className="w-4 h-4 text-white" />
          </div>
          <div className="leading-tight">
            <div className="font-display font-extrabold text-white text-xs">XTM ADMIN</div>
            <div className="text-[9px] uppercase tracking-[0.18em] text-orange-400 font-semibold">FutureSkills</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1" data-testid="admin-nav">
          {ITEMS.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) => `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-orange-600 text-white" : "text-slate-400 hover:text-white hover:bg-navy-hover"}`}
              data-testid={`admin-nav-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              <Icon className="w-4 h-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-xs text-slate-400 mb-1 truncate">{user?.name}</div>
          <div className="text-[10px] text-slate-500 uppercase tracking-wider mb-3">{user?.role}</div>
          <button onClick={async () => { await logout(); navigate("/"); }}
            className="flex items-center gap-2 text-xs text-slate-400 hover:text-orange-400 transition-colors" data-testid="admin-logout">
            <LogOut className="w-3.5 h-3.5" /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-60 p-8 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
